import type { DevToolsPanelFooterProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/DevToolsPanelFooter/index.types';
import { formatUptime } from 'Modules/softphone/components/SoftphoneDevTools/utils';
import React from 'react';

/**
 * DevToolsPanelFooter - Who is registered, for how long, and what time it is
 *
 * Panel-level rather than per-tab, so a screenshot of any tab carries the
 * identity and the clock every other timestamp in the panel is read against.
 */
export const DevToolsPanelFooter: React.FC<DevToolsPanelFooterProps> = ({
  identity,
  registeredAt,
  now,
}) => {
  const uptime = formatUptime(registeredAt, now);

  return (
    <div className="flex h-7 flex-shrink-0 items-center gap-2.5 border-t border-zinc-800 bg-zinc-900 px-3 font-sp-mono text-[10px] text-zinc-400">
      <span
        className="min-w-0 truncate text-[11px] font-medium text-zinc-300"
        title={identity ?? undefined}
      >
        {identity ?? 'not registered'}
      </span>
      {uptime && (
        <>
          <span className="text-zinc-700">│</span>
          <span className="flex-shrink-0">uptime {uptime}</span>
        </>
      )}
      <span className="ml-auto flex-shrink-0">{now.toLocaleTimeString()}</span>
    </div>
  );
};
